import { Reveal } from "@/components/Reveal";
import { TreePine } from "lucide-react";

export const ScreenFree = () => (
  <section className="py-20 sm:py-24" data-testid="screenfree-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[22rem_1fr] lg:gap-16">
        <Reveal>
          <div
            data-testid="screenfree-photo"
            className="mx-auto w-full max-w-xs overflow-hidden rounded-[2rem] border-[6px] border-white shadow-[0_45px_80px_-35px_rgba(18,58,62,0.45)] lg:max-w-none"
          >
            <img
              src="/assets/kaisa-outdoors.jpg"
              alt="Kaisa kahden lapsen kanssa tutkimassa luontoa ulkona"
              className="aspect-[4/5] w-full object-cover"
              loading="lazy"
            />
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="rounded-[2rem] border border-beige-border/70 bg-beige/25 p-8 sm:p-10">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-petrol text-cream shadow-[0_14px_30px_-12px_rgba(18,58,62,0.5)]">
              <TreePine className="h-6 w-6" strokeWidth={1.6} />
            </span>
            <h3 className="mt-6 font-serif text-3xl font-semibold tracking-tight text-petrol-night sm:text-4xl">
              Läsnä lasten kanssa
            </h3>
            <p className="mt-5 text-base leading-relaxed text-mutedink sm:text-lg">
              Hoitoaikana olen sataprosenttisesti lasten kanssa. En tietenkään
              käytä omaa puhelintani työaikana muuhun kuin välttämättömään
              yhteydenpitoon teidän kanssanne – ja lähtökohtaisesti lapsetkin
              ovat ilman näyttöjä: pelataan, leikitään ja ulkoillaan yhdessä.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
